module.exports = __webpack_public_path__ + "static/img/pdf.49d4041b.png";